import styled from 'styled-components';

export enum ButtonType {
	LEFT = 'LEFT',
	RIGHT = 'RIGHT',
	SINGLE = 'SINGLE',
	CENTER = 'CENTER',
}

export const Base = styled.div`
	display: flex;
	gap: 0;
`;

export const Button = styled.div<{ active: boolean; buttonType: ButtonType }>`
	display: flex;
	align-items: center;
	gap: 6px;

	padding: 6px;
	height: 18px;
	padding-left: 11px;
	padding-right: 11px;

	/* Border radius based on button type */
	border-radius: ${({ buttonType }) => {
		switch (buttonType) {
			case ButtonType.LEFT:
				return '12px 0 0 12px';
			case ButtonType.RIGHT:
				return '0 12px 12px 0';
			case ButtonType.CENTER:
				return '0';
			case ButtonType.SINGLE:
				return '12px';
			default:
				return '12px';
		}
	}};
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);

	background: ${({ theme }) => theme.gray[0]};
	&:hover {
		background: ${({ theme, active }) => (active ? theme.gray['100'] : theme.gray['0'])};
	}
	&:active {
		background: ${({ theme, active }) => (active ? theme.gray['200'] : theme.gray['0'])};
	}
`;

export const VerticalLine = styled.div`
	width: 1px;
	height: 30px;
	background: ${({ theme }) => theme.gray['400']};
`;

export const Icon = styled.div`
	// filter out mouse events on the icon, so that all clicks go to the base
	// otherwise Icon will block clicks on Base, and we won't detect when the user clicks the button
	pointer-events: none;
	margin-top: 1px;
`;

interface LabelProps {
	color: string;
}
export const Label = styled.div<LabelProps>`
	font-size: 14px;
	font-weight: 400;
	color: ${({ color }) => color};
`;
